import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import viewRelatedAppSportRoomConfigs from './viewRelatedAppSportRoomConfigs';
import viewRelatedLives from './viewRelatedLives';

export default {
  attributeName: 'liveScheduledProviders',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: false,
  canRemove: false,
  emptyMessage: "You don't have live scheduled providers registered.",
  fields: [
    {
      attributeName: 'name',
      label: 'Service',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'Live scheduled service name.',
    },
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.SELECT,
      helpText: 'Visibility of the video in the panel where its listed.',
      options: [
        { name: 'Paused', value: 'paused' },
        { name: 'Running', value: 'running' },
      ],
      canEdit: true,
      canCreate: false,
      width: '10rem',
    },
    {
      attributeName: 'lastCommandUpdate',
      label: 'Last Run date',
      type: FormInputTypes.TIMESTAMP,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'The last run date was...',
    },
    {
      attributeName: 'lastCommandLog',
      label: 'Last Run result',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'The last commnad result was...',
    },
    {
      attributeName: 'lives',
      label: 'Live Events Preasignated',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: false,
      canFilter: false,
      configFile: viewRelatedLives,
      default: [],
      helpText: 'The events available for this live scheduled provider. The live events can be selected if they are enable with the live scheduled attribute enabled',
    },
    {
      attributeName: 'appConfigs',
      label: 'App/Room configs Preasignated',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: false,
      canFilter: false,
      configFile: viewRelatedAppSportRoomConfigs,
      default: [],
      helpText: 'The app/room configs linked to this event schedule. The selected configs are used to generate the dynamic contents when a new event is registered.',
    },
  ],
};
